module.exports = __webpack_public_path__ + "img/4.bd1bb7df.jpg";